// extracted by css-extract-rspack-plugin
export default {"root":"root-pgzwDi","status":"status-XK7As0","footer":"footer-cZ0IoN"};